<template>
  <requiring-user>
    <header>
      <h1 class="page-title">{{ $t('edit.title') }}</h1>
      <span class="email-title">{{user.email}}</span>
    </header>
    <form-container size="medium">
      <!-- First Name -->

      <b-form-group horizontal
                    :label-cols="3"
                    label-size="sm"
                    label-class="text-sm-left"
                    :label="$t('edit.firstName')"
                    label-for="fn">
        <b-form-input id="fn"
                      name="fn"
                      type="text"
                      v-model="user.firstName"
                      v-bind:disabled="isLoading"
                      v-validate="'required'"
                      :data-vv-as="$t('edit.firstName')"/>
        <span v-show="errors.has('fn')"
              class="form__error">
          {{ errors.first('fn') }}
        </span>
      </b-form-group>

      <!-- Last Name -->

      <b-form-group horizontal
                    :label-cols="3"
                    label-size="sm"
                    label-class="text-sm-left"
                    :label="$t('edit.lastName')"
                    label-for="ln">
        <b-form-input id="ln"
                      name="ln"
                      type="text"
                      v-model="user.lastName"
                      v-bind:disabled="isLoading"
                      v-validate="'required'"
                      :data-vv-as="$t('edit.lastName')"/>
        <span v-show="errors.has('ln')"
              class="form__error">
          {{ errors.first('ln') }}
        </span>
      </b-form-group>

      <!-- Language -->

      <b-form-group horizontal
                    :label-cols="3"
                    label-size="sm"
                    label-class="text-sm-left"
                    :label="$t('edit.language')"
                    label-for="lang">
         <b-form-select id="lang"
                        name="lang"
                        :options="languages"
                        v-model="user.language"
                        v-bind:disabled="isLoading"
                        v-validate="'required'"
                        :data-vv-as="$t('edit.language')"/>
          <span v-show="errors.has('lang')"
                class="form__error">
            {{ errors.first('lang') }}
          </span>
      </b-form-group>

      <!-- Save button -->
      <b-button
        v-if="!isLoading"
        v-bind:disabled="!isValid || isLoading"
        @click="save"
        variant="primary">
          {{ $t('edit.performSave') }}
      </b-button>

      <loading-indicator v-if="isLoading"/>

      <b-alert v-if="infoMsg" variant="info" :show="3">{{ infoMsg }}</b-alert>
      <b-alert v-if="errorMsg" variant="danger" show>{{ errorMsg }}</b-alert>
    </form-container>
  </requiring-user>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'EditScreen',
  data () {
    return {
      user: Object.assign({}, this.$store.state.userData || {}),
      isLoading: false,
      infoMsg: null,
      errorMsg: null
    }
  },
  computed: {
    isValid () {
      return !this.errors.any()
    },
    ...mapState({
      languages: state => state.ui.languages
    }),
    ...mapGetters(['hasUser'])
  },
  methods: {
    async save () {
      if (!this.isValid) {
        return
      }

      this.infoMsg = null
      this.errorMsg = null
      this.isLoading = true

      const params = Object.assign({}, this.user)
      this.$store.commit('setUserData', params)

      try {
        await this.$store.dispatch('saveUserData')
        this.infoMsg = this.$t('edit.succeeded')
      } catch (error) {
        this.errorMsg = error.message
      }

      this.isLoading = false
    }
  },
  watch: {
    hasUser () {
      // reload user data from store if user is logged in after this component was created
      this.user = Object.assign({}, this.$store.state.userData || {})
    }
  }
}
</script>

<style scoped>
.email-title {
  color: gray;
  font-size: 1rem;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/EditScreen.vue